/**
 * Reference manifest for a scorecard criterion header.
 *
 * Epic SP-B (#1387) replaces the rounded-rect scaffold renderer with a
 * criterion header that shows weight, scale (e.g., 1–5 or 1–10), and an
 * `inverse` flag (where lower values are better, like effort or cost).
 */

import { createPlanningManifest, type PlanningNodeProps } from '../manifest-base';

export const ScorecardCriterionManifest = createPlanningManifest({
  id: 'sc_criterion',
  domain: 'scorecard',
  label: 'Criterion',
  accent: '#a855f7',
  icon: 'sliders',
  defaultWidth: 200,
  defaultHeight: 56,
});

export type ScorecardCriterionProps = PlanningNodeProps;
